export enum IconColor {
  Blue800 = 'blue800',
  Blue1000 = 'blue1000',
  Cerise500 = 'cerise500',
  Gray900 = 'gray900',
  Green600 = 'Green600',
  Orange500 = 'orange500',
  Red600 = 'red600',
}
